export default __webpack_public_path__ + "static/media/prodlogos.ba2d1f63.png";